import React from 'react';

const linkIcon = props => (
	<svg className={'link-icon ' + (props.className ? props.className : '')} xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10">
		<path fill={props.fill ? props.fill : '#A1A1A1'} fillRule="evenodd" d="M10.064 0L8.483 1.602l2.236 2.265H4.473C2.006 3.867 0 5.9 0 8.398v1.133h2.236V8.398c0-1.248 1.004-2.265 2.237-2.265h6.246L8.483 8.398 10.064 10 15 5l-4.936-5z" />
	</svg>
);

export default linkIcon;
